function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("polyline", {
  points: "1.5 6 4.5 9 10.5 1"
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 12 10"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/checkbox-tick.3898f7b1.svg";
export { SvgComponent as ReactComponent };